import React from 'react';

import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';

import { getCartPath } from '../routing/flow';

import paymentMessages from './paymentMessages';


const EditCartLink = () => {
    const props = {
        to: {
            pathname: getCartPath(),
            search: window.location.search
        },
        className: 'action-link'
    };

    return (
        <Link {...props}>
            <FormattedMessage {...paymentMessages.editCart} />
        </Link>
    );
};

export default EditCartLink;
